import { render, staticRenderFns } from "./HeaderCompo.vue?vue&type=template&id=5989f80c&"
import script from "./HeaderCompo.vue?vue&type=script&lang=js&"
export * from "./HeaderCompo.vue?vue&type=script&lang=js&"
import style0 from "./HeaderCompo.vue?vue&type=style&index=0&id=5989f80c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports